export default "__VITE_ASSET__BkLzzqgc__"